<template>
<v-app>
      <v-dialog v-model="loading" persistent max-width="290">
      <v-card>
        <v-card-text>
          <v-layout flex align-center justify-center>
            <v-flex xs12 class="text-xs-center">
              <v-progress-circular
              indeterminate
              color="primary"
              :size="50"></v-progress-circular>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="disconnectDialogClicking" max-width="290">
      <v-card>
        <v-card-text>Êtes-vous sûr de vouloir vous déconnecter?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click.native="disconnectDialogClicking = false">Annuler</v-btn>
          <v-btn color="green darken-1" flat="flat" v-on:click="Disconnect">Confirmer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div v-if="!loading">
      <table class="days text-xs-center" >
        <tr>
          <td align="center" v-for="weekday in weekdays" v-bind:style="{ color: weekday.daycolor}" v-on:click="LoadNew(weekday.day, weekday.month, weekday.dayNumber, weekday.monthNumber, weekday.year, weekday.week)">
            {{ weekday.Abrvday }}
          </td>
        </tr>
        <tr>
          <td align="center" v-for="weekday in weekdays" v-bind:style="{ color: weekday.daycolor}" v-on:click="LoadNew(weekday.day, weekday.month, weekday.dayNumber, weekday.monthNumber, weekday.year, weekday.week)">
            <div class="setter" v-bind:class="{ orangeStyle: weekday.isToday, blackStyle: weekday.dmy === SelectedMoment }" >{{ weekday.dayNumber }}</div>
          </td>
        </tr>
      </table>
      <table class="controls">
        <tr>
          <td width="10%" align="center">
            <v-btn small flat icon color="black" v-on:click="PreviousWeek">
              <v-icon medium>fa-chevron-circle-left</v-icon>
            </v-btn>
            <div style="color:black;">S - 1</div>
          </td>
          <td align="center">{{SelectedDay[0]}}</td>
          <td width="10%" align="center">
            <v-btn small flat icon color="black" v-on:click="NextWeek">
              <v-icon medium>fa-chevron-circle-right</v-icon>
            </v-btn>
            <div style="color:black;">S + 1</div>
          </td>
          <td width="10%">
              <span class="orangeStyle setter">S{{this.thisWeek}}</span>
              <div style="color:rgba(255, 102, 51, 1);">S</div>
          </td>
        </tr>
      </table>

      <div class="resutlContainer">
        <table class="result" v-if="!loading" v-for="(chantier, index) in chantiers" :key="index"  v-bind:class="{'greyed':CheckIfComplete(chantier)}">
        <!-- If completed , gris item -->
          <tr v-if="CheckIfComplete(chantier)">
              <td>
                <table width="100%">
                  <tr>
                    <td align="right" colspan="7">
                      <v-badge color="transparent" overlap>
                        <span slot="badge"><v-icon color="green" large>fa-check-square-o</v-icon></span>
                        <v-icon medium>fa-clipboard</v-icon>
                      </v-badge>
                    </td>
                  </tr>
                  <tr>
                    <td width="20%" align="center">
                      <b v-if="typeof chantier.expected_arrival_time != 'undefined' ">
                        <v-icon small>fa-clock-o</v-icon> {{ ExpectedArrivalTime(chantier.expected_arrival_time) }}
                      </b>
                    </td>
                    <td width="80%" colspan="6">
                      <b>{{ clients[chantier.client_uid].name | uppercase }} </b>
                    </td>
                  </tr>
                  <tr>
                    <td style="border-collapse: collapse; border-right:3px solid grey;"></td>
                    <td width="80%" colspan="6">
                      <v-flex d-flex justify-start>
                        <v-icon medium color="grey">fa-map-marker</v-icon>
                        <span>
                          <b> {{ clients[chantier.client_uid].address.address }}</b><br>
                          <b> {{ clients[chantier.client_uid].address.zip_code}} {{clients[chantier.client_uid].address.city}} </b>
                        </span>
                      </v-flex>
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td width="80%" colspan="6">
                      <v-flex d-inline-flex justify-start align-content-start>
                        <div class="action-wrapper">
                          <v-btn  @click.native="gps_clicking = true" icon>
                              <v-icon :color="'grey'" class="icon-wrapper-grey" medium>fa-location-arrow</v-icon>
                          </v-btn>
                          <v-dialog v-model="gps_clicking" max-width="290">
                              <v-card>
                                <v-card-title class="coloredO headline">GPS</v-card-title>
                                <v-card-text>
                                  <gmap-map
                                  :center="GetGeoPostion(chantier.client_uid)"
                                  :zoom="16"
                                  map-type-id="terrain"
                                  style="height: 300px"
                                  >
                                  <GmapMarker
                                  label="★"
                                  :position="GetGeoPostion(chantier.client_uid)"
                                  />
                                </gmap-map>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" flat="flat" @click.native="gps_clicking = false">Fermer</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </div> 
                        <div class="action-wrapper" v-if="chantier.observations">
                          <v-btn  @click.native="observations_clicking = true" icon>
                            <v-icon class="icon-wrapper-grey" :color="'grey'"  medium>fa-newspaper-o</v-icon>
                            <v-dialog v-model="observations_clicking" max-width="290">
                              <v-card>
                                <v-card-title class="coloredO headline">Observations</v-card-title>
                                <v-card-text>{{ chantier.observations }}</v-card-text>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn color="green darken-1" flat="flat" @click.native="observations_clicking = false">Ok</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </v-btn>
                        </div>
                        <div class="action-wrapper" v-if="chantier.information">
                          <v-btn class="greyed"  @click.native="information_clicking = true"  icon>
                            <v-icon class="icon-wrapper-grey" :color="'grey'" medium>fa-info-circle</v-icon>
                            <v-dialog v-model="information_clicking" max-width="290">
                              <v-card>
                                <v-card-title class="coloredO headline">Informations laissées par le controleur</v-card-title>
                                <v-card-text>{{ chantier.information }}</v-card-text>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn color="green darken-1" flat="flat" @click.native="information_clicking = false">Ok</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </v-btn>
                        </div>
                        <div class="action-wrapper g-wrapper-vertical-center" v-if="typeof chantier.pdfs !== 'undefined' && chantier.pdfs.length !== 0">
                          <v-icon class="icon-wrapper-grey"  :color="'grey'"  small>fa-file-pdf-o</v-icon>
                        </div>
                      </v-flex>
                    </td>
                </tr>
              </table>
            </td>
          </tr>
          <!--- if chantier is still open -->
          <tr v-else>
            <td>
                <table width="100%">
                  <tr  v-on:click="ToggleTable(index)">
                    <td align="right" colspan="7">
                      <v-badge color="transparent" overlap>
                        <span slot="badge"><v-icon color="red" large>fa-times</v-icon></span>
                        <v-icon :color="'black'"  medium>fa-clipboard</v-icon>
                      </v-badge>
                    </td>
                  </tr>
                  <tr v-on:click="ToggleTable(index)">
                    <td width="20%" align="center">
                      <b v-if="typeof chantier.expected_arrival_time != 'undefined' ">
                        <v-icon small>fa-clock-o</v-icon> {{ ExpectedArrivalTime(chantier.expected_arrival_time) }}
                      </b>
                    </td>
                    <td width="80%" colspan="6">
                      <b>{{ clients[chantier.client_uid].name | uppercase }} </b>
                    </td>
                  </tr>
                  <tr v-on:click="ToggleTable(index)">
                    <td style="border-collapse: collapse; border-right:3px solid grey;"></td>
                    <td width="80%" colspan="6">
                      <v-flex d-flex justify-start>
                        <v-icon medium color="grey">fa-map-marker</v-icon>
                        <span>
                          <b> {{ clients[chantier.client_uid].address.address }}</b><br>
                          <b> {{ clients[chantier.client_uid].address.zip_code}} {{clients[chantier.client_uid].address.city}} </b>
                        </span>
                      </v-flex>
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td width="80%" colspan="6">
                      <v-flex d-inline-flex justify-start align-content-start>
                        <div class="action-wrapper">
                          <v-btn  @click.native="gps_clicking = true" icon>
                              <v-icon class="icon-wrapper-black" :color="'black'" medium>fa-location-arrow</v-icon>
                          </v-btn>
                          <v-dialog v-model="gps_clicking" max-width="290">
                              <v-card>
                                <v-card-title class="coloredO headline">GPS</v-card-title>
                                <v-card-text>
                                  <gmap-map
                                  :center="GetGeoPostion(chantier.client_uid)"
                                  :zoom="16"
                                  map-type-id="terrain"
                                  style="height: 300px"
                                  >
                                  <GmapMarker
                                  label="★"
                                  :position="GetGeoPostion(chantier.client_uid)"
                                  />
                                </gmap-map>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" flat="flat" @click.native="gps_clicking = false">Fermer</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </div> 
                        <div class="action-wrapper" v-if="chantier.observations">
                          <v-btn  @click.native="observations_clicking = true" icon>
                            <v-icon class="icon-wrapper-orange" :color="'orange darken-4'"  medium>fa-newspaper-o</v-icon>
                            <v-dialog v-model="observations_clicking" max-width="290">
                              <v-card>
                                <v-card-title class="coloredO headline">Observations</v-card-title>
                                <v-card-text>{{ chantier.observations }}</v-card-text>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn color="green darken-1" flat="flat" @click.native="observations_clicking = false">Ok</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </v-btn>
                        </div>
                        <div class="action-wrapper" v-if="chantier.information">
                          <v-btn class="greyed"  @click.native="information_clicking = true"  icon>
                            <v-icon class="icon-wrapper-orange" :color="'orange darken-4'" medium>fa-info-circle</v-icon>
                            <v-dialog v-model="information_clicking" max-width="290">
                              <v-card>
                                <v-card-title class="coloredO headline">Informations laissées par le controleur</v-card-title>
                                <v-card-text>{{ chantier.information }}</v-card-text>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn color="green darken-1" flat="flat" @click.native="information_clicking = false">Ok</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </v-btn>
                        </div>
                        <div class="action-wrapper g-wrapper-vertical-center" v-on:click="ToggleTable(index)" v-if="typeof chantier.pdfs !== 'undefined' && chantier.pdfs.length !== 0">
                          <v-icon class="icon-wrapper-orange" :color="'orange darken-4'" small>fa-file-pdf-o</v-icon>
                        </div>
                      </v-flex>
                    </td>
                </tr>
              </table>
              <div style="display: none;" v-bind:id="index">
                <div align="center" style="width:100%;">
                  <v-icon class="icon-wrapper-black" :color="'black'" medium>fa-calendar-o</v-icon>
                  <b>{{DisplayPeriod(chantier)}}</b>
                </div><br/>
                <!-- PDFs -->
                <div v-if="typeof chantier.pdfs !== 'undefined' && chantier.pdfs.length !== 0" align="center" style="width:100%;">
                  <v-flex d-flex justify-center>
                    <div class="title-half-line-wrapper g-wrapper-vertical-center">
                      <div class="title-half-line"></div>
                    </div>
                    <b class="section-title">{{'FICHIER PDF' | uppercase}} </b>
                    <v-flex class="title-half-line-wrapper g-wrapper-vertical-center" justify-space-around row>
                      <div class="title-half-line"></div>
                    </v-flex>
                  </v-flex>
                </div>
                <div class="pdf-files-container" v-if="typeof chantier.pdfs !== 'undefined' && chantier.pdfs.length !== 0" style="width:100%;" v-for="pdf in chantier.pdfs">
                  <div v-if="typeof pdf !== 'undefined' && pdf.file_name !== 'undefined' && pdf.url !== 'undefined'">
                    <v-icon color="orange darken-3" class="icon-wrapper-orange" small>fa-file-pdf-o</v-icon>
                    <a class="open-pdf-link"  v-on:click="openPDF(pdf.url)"> {{pdf.file_name | uppercase}}</a>
                  </div>
                </div>
                <br/>
                <!-- RAPPORTS -->
                <div align="center" style="width:100%;">
                  <v-flex d-flex justify-center>
                    <div class="title-half-line-wrapper g-wrapper-vertical-center">
                      <div class="title-half-line"></div>
                    </div>
                    <b class="section-title">{{'Choissiez votre rapport' | uppercase}}</b>
                    <v-flex class="title-half-line-wrapper g-wrapper-vertical-center" justify-space-around row>
                      <div class="title-half-line"></div>
                    </v-flex>
                  </v-flex>
                </div>
                <div v-if="role === 'chef_de_pose'">
                  <div align="center" class="btn-report" style="width:100%;">
                    <v-btn dark block round  color="green darken-2">RAPPORT D'INCIDENT <v-icon class='arrow-right' :color="'white'"  medium>fa-angle-right</v-icon></v-btn>
                  </div>
                  <div class="btn-report" v-if="chantier.period.end_date !== SelectedDay[1]" align="center" style="width:100%;">
                    <v-btn dark block round  color="green darken-2">RAPPORT DU JOUR <v-icon class='arrow-right' :color="'white'"  medium>fa-angle-right</v-icon></v-btn>
                  </div>
                  <div class="btn-report" align="center" style="width:100%;">
                    <v-btn dark block round  color="green darken-2">RAPPORT FINAL <v-icon class='arrow-right' :color="'white'"  medium>fa-angle-right</v-icon></v-btn>
                  </div>
                </div>
                <div v-else>
                  <div class="btn-report"  align="center" style="width:100%;">
                    <v-btn dark block round  color="green darken-2">RAPPORT D'INCIDENT <v-icon class='arrow-right' :color="'white'"  medium>fa-angle-right</v-icon></v-btn>
                  </div>
                </div>
              </div>
            </td>
            <!--- End v-else  -->
          </tr>
        <!--- End <table> result -->
      </table>
      <br><br><br>
    </div>
  </div>
  </v-app>
</template>
<script>
import * as firebase from 'firebase'
import moment from 'moment'
import _ from 'lodash'

export default {
  data () {
    return {
      // for user
      firstname: null,
      lastname: null,
      email: null,
      role: null,
      uid: null,
      // Settings
      loading: true,
      disconnectDialogClicking: null,
      gps_clicking: false,
      observations_clicking: false,
      information_clicking: false,
      // Chantier
      clients: [],
      fullChantiers: [],
      chantiers: [],
      RedDays: [],
      weeksCounter: 0,
      weekdays: [],
      thisWeek: null,
      SelectedMoment: null,
      SelectedDay: []
    }
  },
  computed: {
  },
  methods: {
    pluginEnabled: function (pluginName) {
      return this.cordova.plugins.indexOf(pluginName) !== -1
    },
    LoadNew: function (day, month, dayNumber, monthNumber, year) {
      var mdy = monthNumber + '/' + dayNumber + '/' + year
      this.SelectedMoment = mdy
      this.SelectedDay = []
      this.SelectedDay[0] = ''
      if (moment().format('MM/DD/YYYY') === mdy) { this.SelectedDay[0] = 'Aujourd\'hui - ' }
      if (moment().add(-1, 'days').format('MM/DD/YYYY') === mdy) { this.SelectedDay[0] = 'Hier - ' }
      if (moment().add(1, 'days').format('MM/DD/YYYY') === mdy) { this.SelectedDay[0] = 'Demain - ' }
      this.SelectedDay[0] += this.capitalize(day.substring(0, 3)) + ' ' + dayNumber + ' ' + this.capitalize(month) + ' ' + year
      this.SelectedDay[1] = year + '-' + monthNumber + '-' + dayNumber
      this.SoftReload([parseInt(dayNumber), parseInt(monthNumber), parseInt(year)])
    },
    Disconnect: function () {
      firebase.auth().signOut().then(
        () => {
          this.$router.push('/login')
        })
    },
    LoadClients: function () {
      // This component will load all the data
      firebase.database().ref('clients').once('value')
      .then((data) => {
        this.clients = data.val()
        if (_.isEmpty(this.clients)) {
          this.loading = false
        } else {
          this.LoadChantiers()
        }
      })
      .catch(
        (error) => {
          console.log(error)
          this.loading = false
        }
      )
    },
    LoadChantiers: function () {
      firebase.database().ref('chantiers').once('value')
      .then((data) => {
        const obj = data.val()
        for (let key in obj) {
          console.log(key)
          if (this.isValidChantier(obj[key])) {
            this.fullChantiers.push({...obj[key], id: key})
          }
        }
        console.log('this.fullChantiers: ' + this.fullChantiers)
        this.LoadDays()
        this.LoadNew(moment().format('dddd'), moment().format('MMMM'), moment().format('DD'), moment().format('MM'), moment().format('Y'))
      })
      .catch(
        (error) => {
          console.log(error)
          this.loading = false
        }
        )
    },
    isValidChantier: function (chantier) {
      // Todo: And Check report_type_uid valid in next phase
      if ((this.clients[chantier.client_uid] == null)) {
        return false
      }
      if ((this.role === 'chef_de_pose') && (this.uid === chantier.inspecteurs.chef_de_pose_uid)) {
        return true
      } else if (chantier.inspecteurs.monteurs[this.uid] == null) {
        return true
      }
      return false
    },
    Hardload: function () {
      // This is the main loading component of the page, it performs a single database load to locally store all data
      // This serves to exponentially decrease loading time and reduce bandwith useage by performing a single load in the page lifetime
      // load user data
      var user = firebase.auth().currentUser
      this.uid = user.uid
      firebase.database().ref('users/' + user.uid).once('value').then((data) => {
        const obj = data.val()
        this.firstname = obj.firstname
        this.lastname = obj.lastname
        this.email = obj.email
        this.role = obj.role
        console.log(this.firstname)
        this.LoadClients()
      })
      .catch(
        (error) => {
          console.log(error)
          this.loading = false
        }
      )
    },
    SoftReload: function (payload) {
      console.log('SoftReload payload:' + JSON.stringify(payload))
      this.chantiers = []
      const payloadmoment = payload[2] + '-' + payload[1] + '-' + payload[0]
      for (let chantierKey in this.fullChantiers) {
        if (moment(payloadmoment, 'YYYY-MM-DD').isBetween(this.fullChantiers[chantierKey].period.start_date, this.fullChantiers[chantierKey].period.end_date, null, '[]')) {
          this.chantiers.push({...this.fullChantiers[chantierKey], id: chantierKey})
        }
      }
      // console.log('Selected chantiers : ' + JSON.stringify(this.chantiers))
      this.loading = false
    },
    LoadDays: function () {
      // Function to load the day selection toolbar
      var focusedWeek = moment().add(this.weeksCounter, 'weeks')
      this.thisWeek = focusedWeek.isoWeek()
      var days = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche']
      var Abrvdays = ['L', 'M', 'Me', 'J', 'V', 'S', 'D']
      this.weekdays = []
      for (var i = 0; i < days.length; i++) {
        var daycolor = null
        var isred = false
        var isgreen = false
        var ymd = focusedWeek.isoWeekday(days[i]).format('Y-MM-DD')
        console.log('LoadDays ymd : ' + ymd)
        for (let keyChantier in this.fullChantiers) {
          console.log('LoadDays keyChantier : ' + keyChantier)
          let chantier = this.fullChantiers[keyChantier]
          // aquire all results that show on current date
          if (moment(ymd, 'YYYY-MM-DD').isBetween(chantier.period.start_date, chantier.period.end_date, null, '[]') && moment(ymd, 'YYYY-MM-DD').isBefore(moment().format('YYYY-MM-DD'))) {
            // check if final report has been closed
            isgreen = true
            if (chantier.final_report != null && chantier.final_report.status === 'closed') {
              console.log('LoadDays between continue : ' + chantier.final_report.status)
              continue
            } else {
              if (chantier.daily_reports != null && chantier.daily_reports[ymd] != null) {
                console.log('LoadDays between checkiing')
                // final report has been closed, check if the daily report on current day is submitted/closed
                const _dailyReport = chantier.daily_reports[ymd]
                console.log('LoadDays check red ' + _dailyReport)
                // daily report hasn't been submitted for this day
                if (_dailyReport.status === 'closed') {
                  continue
                }
              }
            }
            isred = true
          }
          // End for chantiers
        }
        // all daily reports have been closed
        if (isred === false && isgreen === true) { daycolor = 'green' }
        // at least one daily report hasn't been submitted/completed
        if (isred === true) { daycolor = 'red' }
        var isToday = false
        if (moment().format('MM/DD/YYYY') === moment().day(days[i]).isoWeek(focusedWeek.isoWeek()).format('MM/DD/YYYY')) { isToday = true }
        this.weekdays.push({day: days[i], dayNumber: focusedWeek.isoWeekday(days[i]).format('DD'), week: focusedWeek.isoWeek(), monthNumber: focusedWeek.format('MM'), month: focusedWeek.format('MMMM'), year: focusedWeek.year(), Abrvday: Abrvdays[i], isToday, dmy: focusedWeek.format('MM/DD/Y'), daycolor: daycolor})
      }
    },
    PreviousWeek: function () {
      if (this.weeksCounter > -12) {
        this.weeksCounter--
        this.LoadDays()
      }
    },
    NextWeek: function () {
      if (this.weeksCounter < 5) {
        this.weeksCounter++
        this.LoadDays()
      }
    },
    ToggleTable: function (id) {
      var x = document.getElementById(id)
      if (x.style.display === 'none') {
        x.style.display = 'block'
      } else {
        x.style.display = 'none'
      }
    },
    CheckifFuture: function () {
      if (moment(this.SelectedDay[1], 'YYYY-MM-DD').isAfter(moment().format('YYYY-MM-DD'))) {
        return true
      } else {
        return false
      }
    },
    CheckIfComplete: function (chantier) {
      // console.log('CheckIfComplete : ' + chantier)
      if (chantier == null) {
        return false
      }
      const mDate = this.SelectedDay[1]
      if (typeof chantier.daily_reports !== 'undefined' && chantier.daily_reports[mDate]) {
        return chantier.daily_reports[mDate].status === 'closed'
      }
      if (chantier.final_report) {
        return chantier.final_report.status === 'closed'
      }
      return false
    },
    GreyButton: function (chantier, origincolor) {
      if (this.CheckIfComplete(chantier)) {
        return 'grey'
      } else {
        return origincolor
      }
    },
    ExpectedArrivalTime: function (timeValue) {
      return moment(timeValue, 'HH:mm:ss a').format('HH') + 'h' + moment(timeValue, 'HH:mm:ss a').format('mm')
    },
    DisplayPeriod: function (chantier) {
      return 'DU ' + moment(chantier.period.start_date, 'YYYY-MM-DD').format('DD-MM-YYYY') + ' AU ' + moment(chantier.period.end_date, 'YYYY-MM-DD').format('DD-MM-YYYY')
    },
    GetGeoPostion: function (clientUid) {
      if (this.clients[clientUid] != null) {
        const client = this.clients[clientUid]
        if (client.address == null || client.address.geo_position == null) {
          return {
            lat: 105,
            lng: 17
          }
        }
        return {
          lat: client.address.geo_position.latitude,
          lng: client.address.geo_position.longitude
        }
      }
    },
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    openPDF: function (url) {
      // Vue.cordova.InAppBrowser.open(url, '_blank', 'location=yes')
      window.location.href = url
    }
    // End Methods
  },
  created () {
    this.Hardload()
    moment.locale('fr')
  }
}
</script>
<style>
.headerDivider {
     border-left:1px solid grey;
     margin: 0px 20px;
     min-height:60px;
}
a{
    text-decoration: none;
}
.result {
    border-radius: 10px;
    background: white;
    padding: 5px;
    width: 98%;
    border: 1px solid grey;
    margin-top: 10px;
    margin-left: 1%;
    margin-right: 1%;
}
.resultContainer {
  height: 70vh;
  overflow-y: scroll;
  margin-bottom: 10px;
}
.orangeStyle {
  border-radius:50%;
  background-color: white;
  color: rgba(255, 102, 51, 1);
  position: relative;
  display: inline-block;
}
.section-title {
  white-space: nowrap;
}
.setter {
  border-radius:50%;
  position: relative;
  display: inline-block;
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
}
.blackStyle {
  border-radius:50%;
  background-color: white;
  color: black;
  position: relative;
  display: inline-block;
}
.days {
  min-height: 15vh;
  width: 100%;
  background-color: #252424;
  color: white;
  table-layout: fixed
}
.controls {
  width: 100%;
  background-color: rgba(255, 102, 51, 1);
  color: white;
  border-bottom: 3px solid #252424;
  border-right: 2px solid #252424;
  border-left: 2px solid #252424;
}
.coloredO {
  color: rgba(255, 102, 51, 1);
}
.coloredR {
  color: red;
}
.greyed {
  color: grey!important;
  border-color: grey!important;
}
.btn-report {
  position:relative;
  text-align:center !important;
  align: center !important;
}
.arrow-right {
  position:absolute;
  right: 30px;
  top: 0px;
  bottom: 0px;
}
.title-half-line {
  width: 100%;
  height: 2px;
  background-color: black;  
}
.title-half-line-wrapper {
  width: 100%;
  margin-left: 5px;
  margin-right: 5px;
}
.g-wrapper-vertical-center {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.pdf-files-container {
  margin-top: 10px;
}
.open-pdf-link {
  color : black !important;
}
.action-wrapper {
  margin : 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/Accueil.vue